const UserOccasionsTypes={
    //Users Occasions
    //LOADING
    USER_OCCASIONS_LOADING:"USER_OCCASIONS_LOADING",
    //list
    GET_USER_OCCASIONS_SUCCESS:"GET_USER_OCCASIONS_SUCCESS",
    //details
    GET_USER_OCCASION_DETAILS_SUCCESS:"GET_USER_OCCASION_DETAILS_SUCCESS"
}
export default UserOccasionsTypes